import { fabric } from 'fabric';
import type { Object as FabricObject } from 'fabric/fabric-impl';
import { ensureFonts } from 'shared/fonts';

type Measurable = FabricObject & { initDimensions?: () => void; getObjects?: () => FabricObject[] };

function remeasure(object: Measurable): void {
  object.initDimensions?.();
  object.dirty = true;
  object.getObjects?.().forEach((child) => remeasure(child as Measurable));
}

/**
 * Дорисовывает объекты, когда выбранный шрифт догрузится. Шрифт по ссылке CSS качается лениво, а
 * Fabric меряет текст один раз — без этого текст оставался в запасном шрифте до следующей правки.
 * Кэш ширин глифов сбрасывается целиком (`.claude/docs/fabric-editor-gotchas.md`).
 */
export async function redrawAfterFonts(objects: FabricObject[], render: () => void): Promise<string[]> {
  const failed = await ensureFonts(objects);
  fabric.util.clearFabricFontCache();
  objects.forEach((object) => remeasure(object as Measurable));
  render();
  return failed;
}
